import { DataService, ModalService, NotificationService } from "@bb-vendure/admin-ui/core";
import { forkJoin, take } from "rxjs";
import { DeleteEmailEventTemplateDocument } from "src/generated-gql/graphql";

export const eventEmailTemplateBulkAction = {
    location: "event-email-template-list",
    label: "Delete",
    icon: "remove",
    iconClass: "is-danger",
    onClick: ({injector,selection,hostComponent, clearSelection}) => {
      const modal = injector.get(ModalService);
      const dataService = injector.get(DataService)
      const noti = injector.get(NotificationService);

      modal.dialog({
        title: "Delete Template",
        body: `Are you sure you want to delete ${selection.length} templates?`,
        buttons: [
          { label: "Cancel", type: "secondary", returnValue: false },
          { label: "Delete", type: "danger", returnValue: true },
        ],
      }).pipe(take(1))
      .subscribe((result) => {
        if (result) {
          const deleteObservables = selection.map((item) =>
            dataService.mutate(DeleteEmailEventTemplateDocument, { id: item.id })
          );

          forkJoin(deleteObservables).subscribe(res => {
            noti.success(`Deleted ${(res as any).length} alerts`);
            hostComponent.refresh();
            clearSelection();
          });
        }
      });
    },
  }